import {createSelector} from 'reselect';

const selectState = (state) => state.global;

export const makeSelectIsRTLLanguageSelected = () =>
    createSelector(selectState, (globalState) => globalState.isRTLLanguageSelected);

export const makeSelectIsWebview = () => createSelector(selectState, (globalState) => globalState.isWebview);
